import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OwlOptions } from 'ngx-owl-carousel-o';
 
interface VideoSlide {
  id: string;
}
 
@Component({
  selector: 'app-reels',
  templateUrl: './reels.component.html',
  styleUrls: ['./reels.component.scss'],
})
export class ReelsComponent implements OnInit {
  activeVideoId: string | null = null;
  safeVideoUrl: SafeResourceUrl | null = null;
 
  videoSlides: VideoSlide[] = [
    { id: '75pEvAWiycM' },
    { id: 'xGLvG4e09GU' },
    { id: '_0uvFp8X47s' },
    { id: 'bZAnea4hJLg' },
    { id: 'fha-Jdo-Hs4' },
    { id: 'x-8n1Xzu8j4' },
    { id: 'vAeUqrKve7Y' },
    { id: '6NHI4MrMhbc' },
	{ id: 'f04TCO0Nm8A' },
	{ id: 'N1E4W_RxjDg' },
	{ id: '00fIeifz9po' }
  ];
 
  videoSliderOptions: OwlOptions = {
    loop: true,
    margin: 24,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 4000,
    autoplaySpeed: 800,
    smartSpeed: 800,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 4 },
      1200: { items: 4 },
    },
    navText: [
      "<i class='bx bx-chevron-left'></i>",
      "<i class='bx bx-chevron-right'></i>",
    ],
  };
 
  constructor(private sanitizer: DomSanitizer) {}
 
  ngOnInit(): void {}
 
  getThumbnailUrl(videoId: string): string {
    // Using hqdefault for faster load (maxresdefault is heavier)
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }
 
  openVideo(videoId: string): void {
    this.activeVideoId = videoId;
    this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`
    );
  }
 
  closeVideo(): void {
    this.activeVideoId = null;
    this.safeVideoUrl = null;
  }
}